// Espelha TipoLancamentoEstoqueFabricadoEnum da API.Vendas (ConfigPedidoVenda): o que sai do estoque quando o item do
// pedido é um produto fabricado. "Escolher na venda" é a pergunta do diálogo de lançar estoque.
export enum TipoLancamentoEstoqueFabricadoEnum {
    EscolherNaVenda = 1,
    ProdutoFabricado = 2,
    Componentes = 3,
}
